import { render, staticRenderFns } from "./zdHistList.vue?vue&type=template&id=28db15e0&scoped=true"
import script from "./zdHistList.vue?vue&type=script&lang=js"
export * from "./zdHistList.vue?vue&type=script&lang=js"
import style0 from "./zdHistList.vue?vue&type=style&index=0&id=28db15e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db15e0",
  null
  
)

export default component.exports